// ─── useContextOptions ───────────────────────────────────────────────────────
// Fetches persona and objective options from the backend context API.
// Falls back to hardcoded options on error.

import { useState, useEffect } from 'react';
import { fetchPersonas, fetchObjectives } from '../services/api/backendClient.js';
import { PERSONA_OPTIONS, OBJECTIVE_OPTIONS } from '../constants/options.js';

function humanize(str) {
  return str
    .replace(/-/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}

function toOption(item) {
  const value = item.id || item.value;
  const label = item.label || item.name || humanize(value);
  return { value, label };
}

export function useContextOptions() {
  const [personaOptions, setPersonaOptions] = useState(PERSONA_OPTIONS);
  const [objectiveOptions, setObjectiveOptions] = useState(OBJECTIVE_OPTIONS);

  useEffect(() => {
    let cancelled = false;

    fetchPersonas()
      .then(data => {
        if (cancelled) return;
        const opts = Array.isArray(data) ? data.map(toOption) : [];
        if (opts.length > 0) setPersonaOptions(opts);
      })
      .catch(() => { /* keep fallback */ });

    fetchObjectives()
      .then(data => {
        if (cancelled) return;
        const opts = Array.isArray(data) ? data.map(toOption) : [];
        if (opts.length > 0) setObjectiveOptions(opts);
      })
      .catch(() => { /* keep fallback */ });

    return () => { cancelled = true; };
  }, []);

  return { personaOptions, objectiveOptions };
}
